import React, {useCallback, useState} from 'react';
import EducationForm from './EducationForm';
import {createCurriculumVitaeEducation, deleteCurriculumVitaeEducation, updateCurriculumVitaeEducation} from '../../../../api/curriculumVitaeApi';
import {toast} from 'react-toastify';
import {COMPLETE_CURRICULUM_VITAE_EDUCATION_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy} from '../../../../service/toastService';
import EducationList from './EducationList';
import {useDispatch} from 'react-redux';
import {showModal} from '../../../../redux/system/actions';
import ConfirmModal from '../../../common/modals/ConfirmModal';

const CONFIRM_MODAL_ID = 'confirmModal';

function Education({curriculumVitae, setCurriculumVitae}) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [educations, setEducations] = useState(curriculumVitae.curriculumVitaeEducations || []);
    const [editingEducation, setEditingEducation] = useState(null);
    const [educationToDelete, setEducationToDelete] = useState(null);

    const handleSaveEducation = async (educationData) => {
        try {
            if (editingEducation) {
                const updatedEducation = await updateCurriculumVitaeEducation(educationData);
                const updatedEducations = educations.map((exp) =>
                    exp.id === educationData.id ? updatedEducation.data : exp
                );
                setEducations(updatedEducations);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeEducations: updatedEducations,
                }));

                toast.success('Education updated successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_EDUCATION_TOAST_MESSAGES));
            } else {
                const newEducation = await createCurriculumVitaeEducation(educationData);
                const updatedEducations = [...educations, newEducation.data];
                setEducations(updatedEducations);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeEducations: updatedEducations,
                }))

                toast.success('Education added successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_EDUCATION_TOAST_MESSAGES));
            }

            setEditingEducation(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_EDUCATION_TOAST_MESSAGES));
        }
    };

    const handleDeleteEducation = async () => {
        if (!educationToDelete) return;
        try {
            await deleteCurriculumVitaeEducation(educationToDelete);
            setEducations((prevEducations) => prevEducations.filter((exp) => exp.id !== educationToDelete));
            setCurriculumVitae((prevCv) => {
                const updatedEducations = prevCv.curriculumVitaeEducations.filter((exp) => exp.id !== educationToDelete);
                return {
                    ...prevCv,
                    curriculumVitaeEducations: updatedEducations,
                };
            });
            toast.success('Education deleted successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_EDUCATION_TOAST_MESSAGES));
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_EDUCATION_TOAST_MESSAGES));
        }
    };

    const handleEditEducation = (education) => {
        setEditingEducation(education);
    };

    const confirmDeleteEducation = (educationId) => {
        setEducationToDelete(educationId);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    return (
        <div>
            <h4 className="mb-4" style={{textDecoration: 'underline', textUnderlineOffset: '7px'}}>
                Educations
            </h4>
            <EducationForm curriculumVitaeId={curriculumVitae.id} initialEducation={editingEducation} setEditingEducation={setEditingEducation}
                           onSave={handleSaveEducation}/>
            <EducationList educations={educations} onEdit={handleEditEducation} onDelete={confirmDeleteEducation}/>

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this education?"
                message="This will permanently remove the selected education from your profile. Do you wish to proceed?"
                onConfirm={handleDeleteEducation}
            />
        </div>
    );
}

export default Education;
